<template>
  <div class="m-card">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Card',
  props: {
    href: {
      type: String,
      required: true
    },
    external: {
      type: Boolean
    }
  }
}
</script>

<style lang="less">
@import (reference) "./../../less/shared/utilities.less";
@import "@{frontend_static_less}/public/modules/m-card.less";
</style>
